import { SVGS } from '../../assets';
import { TouchableOpacity } from '../../common';
import './floating-button.scss';

export const FloatingButton = ({
  label,
  onPress,
  btnColor,
}: {
  label: string;
  onPress: () => void;
  btnColor?: string;
}) => (
  <div className="floating-view">
    <div className="btn-container">
      <TouchableOpacity
        className="btn-view"
        onPress={onPress}
        style={{ background: btnColor }}
      >
        <img src={SVGS.AddCircle} />
        <div className="btn-view__text font-semibold">{label}</div>
      </TouchableOpacity>
    </div>
  </div>
);
